import { render, staticRenderFns } from "./AddCustomerUser.vue?vue&type=template&id=4b535139&scoped=true"
import script from "./AddCustomerUser.vue?vue&type=script&lang=js"
export * from "./AddCustomerUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b535139",
  null
  
)

export default component.exports